<div class="products-list-container">
  <!-- Products header bar -->
  <div class="products-header-bar">
    <div class="products-header-info">
      <div class="products-stat">{{ 'Catalogs.new_catalog.products.listing.add_products' | translate }}: </div>
      <div class="products-title">{{ 'inventory.inventory' | translate }}</div>
    </div>
    <div class="products-stats">
      <div class="products-stat">
        {{ getSelectedProductsCount() }} {{ 'quotations_and_orders.product_selected' | translate }}
      </div>
    </div>
  </div>

  <!-- Filter bar -->
  <div class="filter-container">
    <div class="search-filter-group">
      <div class="search-box">
        <input
          type="text"
          [formControl]="nameControleProduct"
          placeholder="{{ 'quotations_and_orders.search_by_product_name' | translate }}"
        />
        <ui-svg-icon svgIcon="search_icon" size="large"></ui-svg-icon>
      </div>

      <div class="filter-button-group">
        <button class="filter-button" (click)="setFilter()" [ngClass]="{ activeFilter: isProductsFiltered }">
          <div class="action-button-icon filter-icon">
            <img src="assets/icones/filter_icon.svg" alt="" />
          </div>
          <span class="action-button-text">{{ 'common.filter' | translate }}</span>
          <div class="clear-icon-container" *ngIf="isProductsFiltered">
            <img
              class="clear-icon"
              (click)="clearFilter(); $event.stopPropagation()"
              src="assets/icones/clear-icon.svg"
              alt=""
            />
            <div class="clear-tooltip">{{ 'common.clear_filters' | translate }}</div>
          </div>
        </button>
      </div>
    </div>
  </div>

  <!-- No products message -->
  <div class="no-products-message" *ngIf="products.length === 0">
    <div class="message-content">
      <p>{{ 'Catalogs.new_catalog.products.listing.no_products_found' | translate }}</p>
    </div>
  </div>

  <!-- Products table -->
  <div class="products-table-container" (scroll)="onScroll($event)">
    <table class="products-table" [formGroup]="quantityForm">
      <thead>
        <tr>
          <th class="table-header header-checkbox">
            <label class="checkbox">
              <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()" />
              <span class="checkmark"></span>
            </label>
          </th>
          <th class="table-header">
            <span class="header-label">{{ 'Catalogs.new_catalog.products.listing.img' | translate }}</span>
          </th>
          <th class="table-header">
            <div class="header-title-with-sort" (click)="sort('name')">
              <span class="header-label">{{ 'quotations_and_orders.product' | translate }}</span>
              <div class="sort-arrows">
                <span class="arrow-up" [class.active]="currentSortField === 'name' && currentSortDirection === 'asc'"></span>
                <span class="arrow-down" [class.active]="currentSortField === 'name' && currentSortDirection === 'desc'"></span>
              </div>
            </div>
            <span class="subheader-label">{{ productCode.primaryLabelKey | translate }}</span>
          </th>
          <th class="table-header">
            <span class="header-label">{{ 'quotations_and_orders.brand' | translate }}</span>
          </th>
          <th class="table-header">
            <div class="header-title-with-sort" (click)="sort('price_unit')">
              <span class="header-label">{{ 'quotations_and_orders.retail_price' | translate }}</span>
              <div class="sort-arrows">
                <span class="arrow-up" [class.active]="currentSortField === 'price_unit' && currentSortDirection === 'asc'"></span>
                <span class="arrow-down" [class.active]="currentSortField === 'price_unit' && currentSortDirection === 'desc'"></span>
              </div>
            </div>
          </th>
          <th class="table-header">
            <div class="header-title-with-sort" (click)="sort('final_price')">
              <span class="header-label">{{ 'quotations_and_orders.unit_price' | translate }}</span>
              <div class="sort-arrows">
                <span class="arrow-up" [class.active]="currentSortField === 'final_price' && currentSortDirection === 'asc'"></span>
                <span class="arrow-down" [class.active]="currentSortField === 'final_price' && currentSortDirection === 'desc'"></span>
              </div>
            </div>
          </th>
          <th class="table-header">
            <div class="header-title-with-sort stock-header" (click)="sort('stock')">
              <span class="header-label">{{ 'inventory.stock' | translate }}</span>
              <div class="sort-arrows">
                <span class="arrow-up" [class.active]="currentSortField === 'stock' && currentSortDirection === 'asc'"></span>
                <span class="arrow-down" [class.active]="currentSortField === 'stock' && currentSortDirection === 'desc'"></span>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let product of currentFilter; trackBy: trackByProduct">
          <tr class="product-row" [class.disabled]="product.disabled">
            <td class="product-cell">
              <label class="checkbox">
                <input type="checkbox" [checked]="product.selected" [disabled]="isSelectionDisabled(product)" (change)="toggleSelectProduct(product)" />
                <span class="checkmark"></span>
              </label>
            </td>
            <td class="product-cell">
              <div class="product-image">
                <img [src]="product.image ? baseUrl + product.image + '?thumbnail=1' : placeholder" alt="" />
              </div>
            </td>
            <td class="product-cell">
              <div class="product-details">
                <div class="product-name">{{ product.name }}</div>
                <div class="product-sku">{{ product | productCode }}</div>
              </div>
            </td>
            <td class="product-cell brand-cell">
              <div class="product-brand">{{ product.brand?.name || '—-' }}</div>
            </td>
            <td class="product-cell price-cell">
              <div class="price-info">{{ getRetailPrice(product) }}</div>
            </td>
            <td class="product-cell">
              <div class="unit-price">
                <ng-container *ngIf="!isQuoteCurrencyMissing(product); else manualFinalPrice">
                  <span class="unit-price-value">{{ getProductFinalPrice(product) }}</span>
                </ng-container>
                <ng-template #manualFinalPrice>
                  <input
                    class="unit-price-input"
                    type="number"
                    [value]="product.final_price ?? ''"
                    (input)="onManualFinalPriceInput($event, product)"
                    placeholder="--"
                  />
                  <span class="unit-price-currency">{{ currency?.symbol || '' }}</span>
                  <span class="missing-price-alert" *ngIf="isFinalPriceMissing(product)">
                    {{ 'Catalogs.new_catalog.products.listing.final_price_missing_single_currency' | translate:{ currency: currency?.name || '' } }}
                  </span>
                </ng-template>
              </div>
            </td>
            <td class="product-cell stock-cell">
              <ng-container *ngIf="!product?.is_owned || product.stock == null; else owned">
                <span class="tag">{{ 'inventory.notOwned' | translate }}</span>
              </ng-container>
              <ng-template #owned>
                <div>{{ product.stock?.quantity }}</div>
              </ng-template>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
